<div class="inicio" *ngIf="empresa">
  <!-- Feedback / Notificações imediatas do sistema -->
  <div class="mb-3" *ngIf="msgStatus">
    <div class="alert alert-success mt-1" role="alert">
      <i class="mdi mdi-check-all mr-2"></i>
      <span [innerHTML]="msgStatus"></span>
      <i class="far fa-times-circle font-20" (click)="fecharAlertaStatus()"
        style="cursor:pointer;position: absolute;top: 10px;right: 10px;" *ngIf="indice === total"></i>
      <div class="mt-2">
        <kendo-progressbar [value]="indice" [max]="total" style="width: 100%;border-radius: 20px;"
                           [progressCssStyle]="{background: 'green'}"></kendo-progressbar>
      </div>
    </div>
  </div>

  <div class="col-12 mt-2 mb-3" *ngIf="msg">
    <div class="alert alert-success mb-0" role="alert">
      <i class="mdi mdi-check-all mr-2"></i> {{msg}}
      <i class="fa fa-print fa-lg ml-1 cpointer" (click)="imprimaPedido(novoPedido)" *ngIf="novoPedido.codigo"></i>
    </div>
  </div>

  <!-- Campanhas pendentes -->
  <div *ngIf="campanhasPendentes?.length" class="mb-3">
    <ng-container *ngFor="let campanhaPendente of campanhasPendentes">
      <div class="alert alert-warning" role="alert">
        <p><strong><i class="fas fa-lightbulb"></i> A rede criou uma nova campanha de marketing via Whatsapp.</strong></p>
        <div>Nome da Campanha: <h4><a href="/campanha/123">{{campanhaPendente.nome}}</a></h4></div>
        <p>Você deve aceitar ou rejeitar a campanha para que ela seja enviada. Qualquer dúvida só falar com o pessoal do suporte.</p>
        <div><button class="btn btn-primary" (click)="cliqueAcessarCampanha(campanhaPendente)">Acessar Campanha</button></div>
      </div>
    </ng-container>
  </div>

  <!-- Fatura em atraso/aberta -->
  <div *ngIf="fatura && !fatura.paga && !fechouAlerta" class="row mb-3">
    <div class="col-12">
      <div class="card fatura-card-home">
        <div class="card-body">
          <button type="button" aria-label="Fechar aviso de fatura" class="fatura-card-home__fechar" (click)="fecheAterta()">
            <span aria-hidden="true">×</span>
          </button>
          <div class="fatura-card-home__cabecalho">
            <span class="fatura-card-home__icone" [class.fatura-card-home__icone--atraso]="fatura.vencida">
              <i class="fas" [ngClass]="fatura.vencida ? 'fa-exclamation-triangle' : 'fa-check'"></i>
            </span>
            <div>
              <h4>{{fatura.vencida ? 'Fatura em atraso' : 'Fatura disponível para pagamento'}}</h4>
              <p>{{fatura.vencida ? 'Evite o bloqueio do sistema efetuando o pagamento.' : 'Realize o pagamento até o vencimento para evitar juros e bloqueios.'}}</p>
            </div>
          </div>
          <div class="fatura-dialog__mensagem" [class.fatura-dialog__mensagem--atraso]="fatura.vencida">
            <i class="fas" [ngClass]="fatura.vencida ? 'fa-exclamation-circle' : 'fa-info-circle'"></i>
            <p *ngIf="!fatura.vencida">
              <strong>Sua fatura já está disponível.</strong>
              Vencimento em <b>{{fatura.dataVencimentoFormatada || fatura.dataVencimento}}</b>. Confira abaixo as formas de pagamento disponíveis.
            </p>
            <p *ngIf="fatura.vencida">
              <strong>Atenção!</strong> A fatura com vencimento em <b>{{fatura.dataVencimentoFormatada || fatura.dataVencimento}}</b> venceu e o pagamento
              não foi identificado no sistema. Caso já tenha realizado o pagamento, envie o comprovante no
              <b>grupo de atendimento do WhatsApp</b> ou entre em contato com o seu consultor.
            </p>
          </div>
          <app-fatura-aberta-pagar #faturaAberta [fatura]="fatura"></app-fatura-aberta-pagar>
        </div>
      </div>
    </div>
  </div>

  <!-- Avisos da plataforma se houver -->
  <div class="card mb-3" *ngIf="temAvisosAtualizacaoParaReabrir">
    <div class="card-body card-avisos-atualizacao">
      <div class="row align-items-center">
        <div class="col-12 col-md-8">
          <div class="d-flex align-items-center flex-wrap mb-2">
            <span class="card-avisos-etiqueta">Avisos da plataforma</span>
            <span class="card-avisos-etiqueta card-avisos-etiqueta--alerta ml-2" *ngIf="avisosAtualizacaoPendentesPorConflito">Pendentes</span>
          </div>
          <h5 class="mb-1">{{ tituloCardAvisosPlataforma }}</h5>
          <p class="mb-1 text-muted" *ngIf="primeiroAvisoAtualizacaoDisponivel"><strong>{{ primeiroAvisoAtualizacaoDisponivel.titulo }}</strong></p>
          <p class="mb-0 text-muted">{{ descricaoCardAvisosPlataforma }}</p>
        </div>
        <div class="col-12 col-md-4 text-md-right mt-3 mt-md-0">
          <button type="button" class="btn btn-outline-primary btn-avisos-home" (click)="abrirAvisosAtualizacaoManualmente()">
            {{ avisosAtualizacaoPendentesPorConflito ? 'Abrir avisos' : 'Ver avisos' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Faixa de prévia: a v2 convive com a home anterior até virar padrão -->
  <div class="home-v2-previa">
    <!-- Depois que a pessoa escolhe, não é mais prévia: é a home dela. -->
    <span class="home-v2-previa__texto"><i class="fas fa-flask"></i> Você está na nova página inicial<span *ngIf="!escolheuHomeNova"> (prévia)</span></span>
    <button type="button" class="home-v2-previa__link" (click)="voltarParaHomeAnterior()">Voltar à versão anterior</button>
  </div>

  <!-- Blocos na ordem do perfil: quem vê vendas entra como dono, o resto como
       operador. A ordem vem de `ordemBlocos`; a presença de cada bloco é a sua
       própria permissão/módulo, dentro do template. -->
  <ng-container *ngFor="let bloco of ordemBlocos; trackBy: identifiqueBloco" [ngSwitch]="bloco">
    <ng-container *ngSwitchCase="'banner'"><ng-container *ngTemplateOutlet="tplBanner"></ng-container></ng-container>
    <ng-container *ngSwitchCase="'pendencias'"><ng-container *ngTemplateOutlet="tplPendencias"></ng-container></ng-container>
    <ng-container *ngSwitchCase="'vendas'"><ng-container *ngTemplateOutlet="tplVendas"></ng-container></ng-container>
    <ng-container *ngSwitchCase="'vendasDetalhe'"><ng-container *ngTemplateOutlet="tplVendasDetalhe"></ng-container></ng-container>
    <ng-container *ngSwitchCase="'fila'"><ng-container *ngTemplateOutlet="tplFila"></ng-container></ng-container>
    <ng-container *ngSwitchCase="'atalhos'"><ng-container *ngTemplateOutlet="tplAtalhos"></ng-container></ng-container>
    <ng-container *ngSwitchCase="'pedidos'"><ng-container *ngTemplateOutlet="tplPedidos"></ng-container></ng-container>
    <ng-container *ngSwitchCase="'cardapio'"><ng-container *ngTemplateOutlet="tplCardapio"></ng-container></ng-container>
    <ng-container *ngSwitchCase="'fidelidade'"><ng-container *ngTemplateOutlet="tplFidelidade"></ng-container></ng-container>
  </ng-container>

  <ng-template #tplBanner>
  <!-- TOP CARD: Status da Loja -->
  <section class="loja-banner" [ngClass]="'loja-banner--' + estadoLoja" *ngIf="temModuloPedidos">
    <div class="loja-banner__esquerda">
      <div class="loja-banner__farol-box">
        <span class="loja-banner__farol-ponto"></span>
      </div>
      <div class="loja-banner__info">
        <div class="loja-banner__titulo-linha">
          <h4 class="loja-banner__titulo">{{tituloEstadoLoja}}</h4>
          <span class="badge-ao-vivo" *ngIf="estadoLoja === 'aberta'">Ao vivo</span>
        </div>
        <p class="loja-banner__subtitulo">{{detalheEstadoLoja}}</p>
      </div>
    </div>

    <div class="loja-banner__direita">
      <!-- O link do cardápio mora no banner: é o que o dono mais manda no
           WhatsApp, e assim fica a um toque sem rolar a página. O QR abre
           ampliado por cima da tela, em tamanho de impressão. -->
      <ng-container *ngIf="!contaNova">
        <button type="button" class="chip-link" [class.chip-link--copiado]="linkCopiado" (click)="copieLinkDaLoja()"
                [title]="linkCardapio" aria-label="Copiar link do cardápio">
          <i class="far" [ngClass]="linkCopiado ? 'fa-check-circle' : 'fa-copy'"></i>
          <span class="chip-link__texto">{{linkCopiado ? 'Link copiado!' : linkCardapioCurto}}</span>
          <span class="chip-link__rotulo">{{linkCopiado ? 'Copiado!' : 'Copiar link'}}</span>
        </button>
        <button type="button" class="btn-loja-acao btn-loja-acao--qr" (click)="mostrarQrCode = true" aria-label="Ver QR Code do cardápio">
          <i class="fas fa-qrcode"></i>
          <span>QR Code</span>
        </button>
      </ng-container>

      <button type="button" class="btn-loja-acao" *ngIf="podeGerenciarLoja && estadoLoja === 'aberta'" (click)="fecharAgora()">
        <i class="fas fa-power-off"></i>
        <span>Pausar loja</span>
      </button>

      <button type="button" class="btn-loja-acao btn-loja-acao--reabrir" *ngIf="podeGerenciarLoja && estadoLoja === 'pausada'" [disabled]="reabrindoLoja" (click)="reabrir()">
        <i class="fas fa-play"></i>
        <span>{{reabrindoLoja ? 'Reabrindo...' : 'Reabrir loja'}}</span>
      </button>

      <a class="btn-loja-acao" *ngIf="podeGerenciarLoja && estadoLoja === 'fechada'" routerLink="/admin/loja/tab/horarios">
        <i class="fas fa-clock"></i>
        <span>Ver horários</span>
      </a>

      <!-- O mesmo botão da home antiga: recarrega o cardápio nas abas e força o envio das mensagens. -->
      <button type="button" class="btn-loja-acao btn-loja-acao--icone" (click)="recarregue()"
              title="Recarregar o cardápio e forçar envio das mensagens." aria-label="Recarregar o cardápio e forçar envio das mensagens">
        <i class="fas fa-sync-alt"></i>
      </button>
    </div>
  </section>

  </ng-template>

  <!-- QR ampliado por cima da página: sem rota, sem aba nova. -->
  <div class="qr-sobreposicao" *ngIf="mostrarQrCode" (click)="mostrarQrCode = false">
    <div class="qr-sobreposicao__cartao" role="dialog" aria-label="QR Code do cardápio" (click)="$event.stopPropagation()">
      <button type="button" class="qr-sobreposicao__fechar" (click)="mostrarQrCode = false" aria-label="Fechar">
        <i class="fas fa-times"></i>
      </button>
      <img class="qr-sobreposicao__imagem" [src]="'/qrcode/qrcodeloja'" alt="QR Code da loja"
           (error)="qrcodeErro = true" *ngIf="!qrcodeErro" />
      <div class="qr-sobreposicao__placeholder" *ngIf="qrcodeErro"><i class="fas fa-qrcode"></i></div>
      <p class="qr-sobreposicao__link">{{linkCardapio}}</p>
      <p class="qr-sobreposicao__dica">Aponte a câmera do celular para abrir o cardápio. Imprima e cole nas mesas ou no balcão.</p>
      <div class="qr-sobreposicao__acoes">
        <a class="btn-cardapio btn-cardapio--copiar" href="/qrcode/qrcodeloja" download="qrcode-cardapio.png">
          <i class="fas fa-download"></i> Baixar PNG
        </a>
        <button type="button" class="btn-cardapio btn-cardapio--outline" [class.copiado]="linkCopiado" (click)="copieLinkDaLoja()">
          <i class="far" [ngClass]="linkCopiado ? 'fa-check-circle' : 'fa-copy'"></i>
          {{linkCopiado ? 'Link copiado!' : 'Copiar link'}}
        </button>
        <a class="btn-cardapio btn-cardapio--outline" [href]="linkCardapio" target="_blank" rel="noopener">
          <i class="fas fa-external-link-alt"></i> Abrir loja
        </a>
      </div>
    </div>
  </div>

  <ng-template #tplPendencias>
  <!-- Pendências operacionais (se houver) -->
  <section class="inicio-pendencias" *ngIf="pendencias.length">
    <div class="inicio-pendencias__lista">
      <button type="button" class="inicio-pendencia" *ngFor="let pendencia of pendencias; trackBy: identifiquePendencia"
              [class.inicio-pendencia--urgente]="pendencia.urgente" (click)="abraPendencia(pendencia)">
        <i class="fas" [ngClass]="pendencia.urgente ? 'fa-exclamation-circle' : 'fa-info-circle'" aria-hidden="true"></i>
        {{pendencia.texto}}
        <i class="fas fa-arrow-right inicio-pendencia__seta" aria-hidden="true"></i>
      </button>
    </div>
  </section>

  </ng-template>

  <ng-template #tplVendas>
  <!-- SEÇÃO 1: Vendas (só quem vê relatórios). Ritmo: um card por pergunta,
       largura inteira, do número ao detalhe. -->
  <section class="secao-vendas" *ngIf="exibirSecaoDesempenho">

    <!-- 1. Quanto vendi, e como está indo -->
    <div class="vendas-card" *ngIf="temModuloPedidos">
      <div class="vendas-card__topo">
        <div>
          <h3 class="secao-titulo">Vendas <ng-container *ngTemplateOutlet="seloGestorTpl"></ng-container><ng-container *ngTemplateOutlet="olhoTpl"></ng-container></h3>
          <!-- O período já está nos botões ao lado; aqui só o que eles não dizem. -->
          <p class="secao-subtitulo" *ngIf="horaResumoHoje">atualizado às {{horaResumoHoje}}</p>
        </div>

        <div class="periodo-filtros">
          <button type="button" class="periodo-btn" [class.ativo]="filtroPeriodo === 'hoje'" (click)="mudarFiltroPeriodo('hoje')">Hoje</button>
          <button type="button" class="periodo-btn" [class.ativo]="filtroPeriodo === 'ontem'" (click)="mudarFiltroPeriodo('ontem')">Ontem</button>
          <button type="button" class="periodo-btn" [class.ativo]="filtroPeriodo === '7dias'" (click)="mudarFiltroPeriodo('7dias')">7 dias</button>
          <button type="button" class="periodo-btn" [class.ativo]="filtroPeriodo === '30dias'" (click)="mudarFiltroPeriodo('30dias')">30 dias</button>
          <button type="button" class="periodo-btn" [class.ativo]="filtroPeriodo === 'mes'" (click)="mudarFiltroPeriodo('mes')">Mês</button>
        </div>
      </div>

      <!-- Faixa de números: rótulo, valor e só o chip de variação. A referência
           completa (ontem até tal hora: R$ X) fica no title. -->
      <div class="vendas-faixa" [class.vendas-faixa--carregando]="carregandoPeriodoAtual">
        <div class="vendas-faixa__item vendas-faixa__item--principal">
          <span class="vendas-faixa__rotulo">Faturamento</span>
          <span class="vendas-faixa__linha">
            <span class="vendas-faixa__valor"><small>R$</small><ng-container *ngTemplateOutlet="numeroTpl; context: {$implicit: resumoExibicao.totalComTaxa}"></ng-container></span>
            <ng-container *ngTemplateOutlet="chipTpl; context: {$implicit: comparativoVendas}"></ng-container>
          </span>
          <!-- Sem variação para mostrar, a referência vem por extenso — uma vez,
               no número principal, em vez de um "sem base" em cada um dos quatro. -->
          <span class="vendas-faixa__base" *ngIf="!comparativoVendas.chip && comparativoVendas.texto">{{comparativoVendas.texto}}</span>
        </div>
        <div class="vendas-faixa__item">
          <span class="vendas-faixa__rotulo">Pedidos</span>
          <span class="vendas-faixa__linha">
            <span class="vendas-faixa__valor"><ng-container *ngTemplateOutlet="qtdeTpl; context: {$implicit: resumoExibicao.qtde || 0}"></ng-container></span>
            <ng-container *ngTemplateOutlet="chipTpl; context: {$implicit: comparativoPedidos}"></ng-container>
          </span>
        </div>
        <div class="vendas-faixa__item">
          <span class="vendas-faixa__rotulo">Ticket médio</span>
          <span class="vendas-faixa__linha">
            <span class="vendas-faixa__valor"><small>R$</small><ng-container *ngTemplateOutlet="numeroTpl; context: {$implicit: resumoExibicao.ticketMedio}"></ng-container></span>
            <ng-container *ngTemplateOutlet="chipTpl; context: {$implicit: comparativoTicket}"></ng-container>
          </span>
        </div>
        <div class="vendas-faixa__item">
          <span class="vendas-faixa__rotulo">Taxas de entrega</span>
          <span class="vendas-faixa__linha">
            <span class="vendas-faixa__valor"><small>R$</small><ng-container *ngTemplateOutlet="numeroTpl; context: {$implicit: resumoExibicao.taxaDeEntrega}"></ng-container></span>
            <ng-container *ngTemplateOutlet="chipTpl; context: {$implicit: comparativoTaxas}"></ng-container>
          </span>
        </div>
      </div>

      <div class="vendas-grafico">
        <p class="vendas-grafico__legenda">{{legendaGrafico}}</p>
        <div class="vendas-grafico__vazio" *ngIf="!temSerieVendas">Sem venda registrada {{graficoPorHora ? 'neste dia nem no anterior' : 'nesses dias'}}</div>
        <!-- No celular o padrão é a curva desenhada pequena com a melhor hora
             escrita ao lado: é o que se lê num relance. Os números e o gráfico
             cheio continuam a um toque. -->
        <div class="mini-serie" *ngIf="temSerieVendas && telaEstreita && !mostrarGraficoNoCelular && !mostrarNumerosNoCelular">
          <div class="mini-barras" aria-hidden="true">
            <span class="mini-barras__coluna" *ngFor="let barra of barrasSerie"
                  [class.mini-barras__coluna--melhor]="barra.melhor"
                  [class.mini-barras__coluna--vazia]="!barra.valor"
                  [style.height.%]="barra.altura"
                  [title]="barra.rotulo + ' · ' + (moeda(barra.valor))"></span>
          </div>
          <div class="mini-serie__rodape">
            <span class="mini-serie__melhor" *ngIf="melhorPontoSerie">
              {{rotuloMelhorPonto}} <strong>{{melhorPontoSerie.rotulo}}</strong> · <ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: melhorPontoSerie.valor}"></ng-container>
            </span>
            <span class="mini-serie__melhor" *ngIf="!melhorPontoSerie">Sem venda {{descricaoPeriodo | lowercase}}</span>
            <span class="mini-serie__links">
              <button type="button" class="serie-compacta__link" (click)="mostrarNumerosNoCelular = true">Números ▸</button>
              <button type="button" class="serie-compacta__link" (click)="mostrarGraficoNoCelular = true">Gráfico ▸</button>
            </span>
          </div>
        </div>

        <div class="serie-compacta" *ngIf="temSerieVendas && telaEstreita && !mostrarGraficoNoCelular && mostrarNumerosNoCelular">
          <div class="serie-compacta__linha serie-compacta__linha--cabecalho">
            <span>{{graficoPorHora ? 'Hora' : 'Dia'}}</span>
            <span class="num">{{nomeSerieAtual}}</span>
            <span class="num" *ngIf="temSerieAnterior">{{nomeSerieAnterior}}</span>
          </div>
          <div class="serie-compacta__linha" *ngFor="let linha of serieCompacta">
            <span>{{linha.rotulo}}</span>
            <span class="num forte"><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: linha.atual}"></ng-container></span>
            <span class="num" *ngIf="temSerieAnterior">{{linha.anterior === null ? '—' : (moeda(linha.anterior))}}</span>
          </div>
          <div class="serie-compacta__rodape">
            <button type="button" class="serie-compacta__link" (click)="voltarParaResumoDaSerie()">◂ Resumo</button>
            <button type="button" class="serie-compacta__link" (click)="mostrarGraficoNoCelular = true">Ver gráfico ▸</button>
          </div>
        </div>

        <div class="grafico-area" #graficoArea *ngIf="temSerieVendas && (!telaEstreita || mostrarGraficoNoCelular)" (mouseleave)="escondaBalao()">
        <kendo-chart [transitions]="false" [style.height.px]="isMobile ? 210 : 320"
                     (plotAreaHover)="mostreBalao($event)" (plotAreaLeave)="escondaBalao()">
          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [categories]="rotulosVendas" [majorGridLines]="{ visible: false }" [line]="{ color: '#e2e8f0' }">
              <kendo-chart-category-axis-item-labels [rotation]="isMobile ? 0 : rotacaoRotulosVendas" [step]="passoRotulosVendas" [font]="fonteGrafico" [color]="corRotuloGrafico">
              </kendo-chart-category-axis-item-labels>
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>
          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item [min]="0" [majorGridLines]="{ color: '#eef2f7' }" [line]="{ visible: false }">
              <kendo-chart-value-axis-item-labels format="c0" [visible]="!valoresOcultos" [font]="fonteGrafico" [color]="corRotuloGrafico">
              </kendo-chart-value-axis-item-labels>
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>
          <kendo-chart-legend [visible]="false"></kendo-chart-legend>
          <kendo-chart-area [margin]="6" background="transparent"></kendo-chart-area>
          <!-- O balão nativo abre num popup no body, com animação, e vinha
               achatado (altura zero). O nosso é um div aqui dentro, posicionado
               pelo hover da área do gráfico: sem popup, sem animação, sem CSS
               global no caminho. -->
          <kendo-chart-tooltip [visible]="false"></kendo-chart-tooltip>
          <kendo-chart-series>
            <kendo-chart-series-item [data]="serieVendas" [type]="'area'" color="#4f46e5" [opacity]="0.12"
                                     [line]="{ width: 0 }" [markers]="{ visible: false }" [tooltip]="{ visible: false }">
            </kendo-chart-series-item>
            <kendo-chart-series-item [data]="serieAnterior" [type]="'line'" color="#94a3b8" [width]="1.5"
                                     [name]="nomeSerieAnterior" [dashType]="'dash'" [missingValues]="'gap'"
                                     [markers]="{ visible: false }" *ngIf="temSerieAnterior">
            </kendo-chart-series-item>
            <kendo-chart-series-item [data]="serieVendas" [type]="'line'" color="#4f46e5" [width]="2" [name]="nomeSerieAtual"
                                     [markers]="{ visible: true, size: 6, background: '#ffffff', border: { color: '#4f46e5', width: 2 } }">
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>

        <div class="grafico-tooltip balao-grafico" *ngIf="balao" [style.left.px]="balao.x" [style.top.px]="balao.y">
          <div class="grafico-tooltip__dia">{{balao.categoria}}<span *ngIf="balao.diaAnterior"> · vs. {{balao.diaAnterior}}</span></div>
          <div class="grafico-tooltip__linha">
            <span class="grafico-tooltip__ponto"></span>
            <span class="grafico-tooltip__nome">{{nomeSerieAtual}}</span>
            <strong><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: balao.atual}"></ng-container></strong>
          </div>
          <div class="grafico-tooltip__linha" *ngIf="temSerieAnterior">
            <span class="grafico-tooltip__ponto grafico-tooltip__ponto--anterior"></span>
            <span class="grafico-tooltip__nome">{{nomeSerieAnterior}}</span>
            <strong>{{balao.anterior === null ? '—' : (moeda(balao.anterior))}}</strong>
          </div>
        </div>
        </div>
        <div class="grafico-legenda" *ngIf="temSerieVendas && (!telaEstreita || mostrarGraficoNoCelular)">
          <span class="grafico-legenda__item"><span class="grafico-legenda__traco"></span>{{nomeSerieAtual}}</span>
          <span class="grafico-legenda__item" *ngIf="temSerieAnterior"><span class="grafico-legenda__traco grafico-legenda__traco--anterior"></span>{{nomeSerieAnterior}}</span>
          <button type="button" class="serie-compacta__link" *ngIf="telaEstreita" (click)="voltarParaResumoDaSerie()">◂ Resumo</button>
        </div>
      </div>
    </div>

  </section>

  </ng-template>

  <ng-template #tplVendasDetalhe>
  <!-- O detalhe do dinheiro: de onde veio, por onde veio e o que mais saiu. -->
  <section class="secao-vendas" *ngIf="exibirSecaoDesempenho">

    <!-- 2. De onde vem o número -->
    <div class="vendas-card" *ngIf="temModuloPedidos">
      <div class="vendas-card__topo vendas-card__topo--compacto">
        <div>
          <h4 class="vendas-card__titulo">Composição do faturamento <ng-container *ngTemplateOutlet="seloGestorTpl"></ng-container><ng-container *ngTemplateOutlet="olhoTpl"></ng-container></h4>
          <p class="secao-subtitulo">Produtos mais as taxas cobradas do cliente</p>
        </div>
      </div>

      <!-- A proporção primeiro, numa barra só: dispensa um ícone por parcela. -->
      <div class="composicao-barra" *ngIf="segmentosComposicao.length">
        <span class="composicao-barra__parte" *ngFor="let segmento of segmentosComposicao"
              [ngClass]="'composicao-barra__parte--' + segmento.chave"
              [style.width.%]="segmento.pct" [title]="segmento.rotulo + ' · ' + segmento.pct + '%'"></span>
      </div>

      <div class="composicao">
        <div class="composicao__parcela" *ngFor="let parcela of composicaoComValor"
             [ngClass]="'composicao__parcela--' + parcela.sinal">
          <span class="composicao__ponto" [ngClass]="'composicao__ponto--' + parcela.chave"></span>
          <span class="composicao__rotulo">
            {{parcela.rotulo}}
            <small class="composicao__detalhe" *ngIf="parcela.detalhe">{{parcela.detalhe}}</small>
          </span>
          <span class="composicao__valor"><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: parcela.valor}"></ng-container></span>
        </div>
        <p class="composicao__zerada" *ngIf="composicaoZerada">{{composicaoZerada}}</p>
      </div>
    </div>

    <!-- 3. Por onde vendi: uma dimensão de cada vez, com profundidade -->
    <div class="vendas-card" *ngIf="temModuloPedidos">
      <div class="vendas-card__topo vendas-card__topo--compacto">
        <div>
          <h4 class="vendas-card__titulo analise-titulo">
            Análise dos pedidos por
            <span class="analise-seletor">
              <select class="analise-seletor__campo" [(ngModel)]="dimensaoAnalise" aria-label="Dimensão da análise">
                <option *ngFor="let dimensao of dimensoesAnalise" [value]="dimensao.chave">{{dimensao.rotulo}}</option>
              </select>
              <i class="fas fa-chevron-down"></i>
            </span>
            <ng-container *ngTemplateOutlet="seloGestorTpl"></ng-container><ng-container *ngTemplateOutlet="olhoTpl"></ng-container>
          </h4>
          <p class="secao-subtitulo">Faturamento, pedidos e ticket por {{rotuloDimensaoAnalise | lowercase}}</p>
        </div>
        <button type="button" class="vendas-card__link" (click)="abraRelatorioVendas()">Ver relatório completo ▸</button>
      </div>

      <!-- Por forma de pagamento conta o que foi PAGO: pedido aberto sem
           pagamento lançado não aparece aqui mesmo entrando no faturamento. -->
      <div class="tabela-vazia" *ngIf="!linhasAnalise.length">
        {{dimensaoAnalise === 'pagamento' ? 'Sem pagamento registrado no período' : 'Sem venda no período'}}
      </div>

      <!-- No celular a tabela vira lista: o que era coluna desce como legenda,
           em vez de espremer cinco colunas ou empurrar scroll lateral. -->
      <div class="lista-compacta" *ngIf="linhasAnalise.length && telaEstreita">
        <div class="lista-compacta__linha" *ngFor="let linha of linhasAnalise; trackBy: identifiqueLinhaDistribuicao">
          <span class="lista-compacta__nome">
            {{linha.nome}}
            <small><ng-container *ngTemplateOutlet="qtdeTpl; context: {$implicit: linha.qtde}"></ng-container> {{linha.qtde === 1 && !valoresOcultos ? 'pedido' : 'pedidos'}} · ticket <ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: linha.ticket}"></ng-container></small>
          </span>
          <span class="lista-compacta__valor">
            <ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: linha.total}"></ng-container>
            <small>{{linha.fatia}}%</small>
          </span>
          <span class="lista-compacta__barra"><span [style.width.%]="linha.fatia"></span></span>
        </div>
      </div>

      <table class="tabela-larga" *ngIf="linhasAnalise.length && !telaEstreita">
        <thead>
          <tr>
            <th>{{rotuloDimensaoAnalise}}</th>
            <th class="num">Faturamento</th>
            <th class="num">Pedidos</th>
            <th class="num">Ticket médio</th>
            <th class="fatia">Participação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let linha of linhasAnalise; trackBy: identifiqueLinhaDistribuicao">
            <td class="nome">{{linha.nome}}</td>
            <td class="num forte"><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: linha.total}"></ng-container></td>
            <td class="num"><ng-container *ngTemplateOutlet="qtdeTpl; context: {$implicit: linha.qtde}"></ng-container></td>
            <td class="num"><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: linha.ticket}"></ng-container></td>
            <td class="fatia">
              <span class="fatia__barra"><span [style.width.%]="linha.fatia"></span></span>
              <span class="fatia__pct">{{linha.fatia}}%</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- 4. O que mais saiu -->
    <div class="vendas-card" *ngIf="temModuloPedidos">
      <div class="vendas-card__topo vendas-card__topo--compacto">
        <div>
          <h4 class="vendas-card__titulo">Mais vendidos <ng-container *ngTemplateOutlet="seloGestorTpl"></ng-container><ng-container *ngTemplateOutlet="olhoTpl"></ng-container></h4>
          <p class="secao-subtitulo">Produtos por quantidade</p>
        </div>
      </div>

      <div class="tabela-vazia" *ngIf="!maisVendidos.length">Nenhum produto vendido no período</div>

      <div class="lista-compacta lista-compacta--ranking" *ngIf="maisVendidos.length && telaEstreita">
        <div class="lista-compacta__linha" *ngFor="let produto of maisVendidos; let i = index">
          <span class="lista-compacta__posicao">{{i + 1}}</span>
          <span class="lista-compacta__nome">
            {{produto.nome}}
            <small><ng-container *ngTemplateOutlet="qtdeTpl; context: {$implicit: produto.qtdeDescricao || produto.qtde}"></ng-container> vendidos</small>
          </span>
          <span class="lista-compacta__valor">
            <ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: produto.total}"></ng-container>
            <small>{{fatiaDoProduto(produto)}}%</small>
          </span>
          <span class="lista-compacta__barra"><span [style.width.%]="fatiaDoProduto(produto)"></span></span>
        </div>
      </div>

      <table class="tabela-larga" *ngIf="maisVendidos.length && !telaEstreita">
        <thead>
          <tr>
            <th class="pos"></th>
            <th>Produto</th>
            <th class="num">Quantidade</th>
            <th class="num">Faturamento</th>
            <th class="fatia">Participação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let produto of maisVendidos; let i = index">
            <td class="pos"><span class="ranking__posicao">{{i + 1}}</span></td>
            <td class="nome">{{produto.nome}}</td>
            <td class="num"><ng-container *ngTemplateOutlet="qtdeTpl; context: {$implicit: produto.qtdeDescricao || produto.qtde}"></ng-container></td>
            <td class="num forte"><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: produto.total}"></ng-container></td>
            <td class="fatia">
              <span class="fatia__barra"><span [style.width.%]="fatiaDoProduto(produto)"></span></span>
              <span class="fatia__pct">{{fatiaDoProduto(produto)}}%</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  </ng-template>

  <ng-template #tplFila>
  <!-- Fila agora: o que está esperando alguém fazer algo -->
  <section class="secao-fila" *ngIf="temModuloPedidos && filaAgora">
    <div class="secao-fila__topo">
      <div class="secao-fila__titulos">
        <h3 class="secao-titulo">
          Fila de Pedidos Agora
          <!-- A explicação do recorte não cabe no cabeçalho do celular, mas não
               pode sumir: fica a um toque, aberta no lugar. -->
          <button type="button" class="btn-nota" [class.btn-nota--ativo]="mostrarNotaFila"
                  [attr.aria-expanded]="mostrarNotaFila" aria-label="O que entra nesta contagem"
                  (click)="mostrarNotaFila = !mostrarNotaFila">
            <i class="fas fa-info-circle"></i>
          </button>
        </h3>
        <p class="secao-subtitulo" *ngIf="mostrarNotaFila">Os mesmos pedidos da aba "Em aberto" da tela de pedidos<span *ngIf="filaAgora?.total"> ({{filaAgora.total}} no total)</span>. À parte, "atrasados" é o que está aberto há mais de {{toleranciaAtraso}} min</p>
      </div>
      <div class="secao-fila__direita">
        <span class="secao-fila__hora" *ngIf="horaFilaAgora">atualizado {{horaFilaAgora}}</span>
        <button type="button" class="btn-atualizar" (click)="atualizeTudo()" [disabled]="atualizando" title="Recarregar fila, operação, últimos pedidos e vendas">
          <i class="fas fa-sync-alt" [class.btn-atualizar__girando]="atualizando"></i> Atualizar
        </button>
      </div>
    </div>

    <div class="fila-grid">
      <button type="button" class="fila-celula" *ngFor="let celula of etapasFila; trackBy: identifiqueCelulaFila"
              [ngClass]="'fila-celula--' + celula.tom" [class.fila-celula--vazia]="!celula.quantidade"
              (click)="abraCelulaFila(celula)">
        <span class="fila-celula__rotulo">{{celula.rotulo}}</span>
        <span class="fila-celula__pulso" *ngIf="celula.tom === 'novo' && celula.quantidade"></span>
        <span class="fila-celula__numero">{{celula.quantidade}}</span>
        <span class="fila-celula__rodape">
          <span class="fila-celula__acao">{{celula.acao}} ›</span>
          <span class="fila-celula__nota" *ngIf="celula.nota">{{celula.nota}}</span>
        </span>
      </button>
    </div>

    <!-- Atrasado é recorte das quatro etapas, não uma quinta: vira aviso em
         faixa, e some quando não há nenhum. -->
    <button type="button" class="fila-atrasados" *ngIf="celulaAtrasados && celulaAtrasados.quantidade"
            (click)="abraCelulaFila(celulaAtrasados)">
      <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
      <span class="fila-atrasados__texto">
        <strong>{{celulaAtrasados.quantidade}}</strong>
        {{celulaAtrasados.quantidade === 1 ? 'pedido aberto' : 'pedidos abertos'}} há mais de {{toleranciaAtraso}} min
      </span>
      <span class="fila-atrasados__acao">ver ▸</span>
    </button>
  </section>

  </ng-template>

  <ng-template #tplAtalhos>
  <!-- SEÇÃO 2: Atalhos Operacionais Rápidos -->
  <section class="secao-atalhos" *ngIf="temAtalhos">
    <div class="secao-atalhos__titulos">
      <h3 class="secao-titulo">Atalhos rápidos</h3>
      <p class="secao-subtitulo">Ações frequentes para agilizar o atendimento no balcão e no delivery</p>
    </div>

    <div class="atalhos-grid">
      <!-- 1. Novo Pedido (Destaque Índigo/Roxo) -->
      <button type="button" class="atalho-card atalho-card--destaque" *ngIf="temModuloPedidos" (click)="abraNovoPedido()">
        <div class="atalho-card__icone">
          <i class="fas fa-plus-circle"></i>
        </div>
        <span class="atalho-card__titulo">Novo Pedido</span>
        <span class="atalho-card__subtitulo">Balcão / Mesa</span>
      </button>

      <!-- 2. Acompanhar -->
      <button type="button" class="atalho-card" *ngIf="temModuloPedidos" (click)="abraAcompanharPedidos()">
        <div class="atalho-card__icone atalho-card__icone--acompanhar">
          <i class="fas fa-clipboard-list"></i>
        </div>
        <span class="atalho-card__titulo">Acompanhar</span>
        <span class="atalho-card__subtitulo">Fila de preparo</span>
      </button>

      <!-- 3. Novo Cartão -->
      <button type="button" class="atalho-card" *ngIf="temModuloFidelidade && temPermissaoAdicionarPontos" (click)="openNovoCartao()">
        <div class="atalho-card__icone atalho-card__icone--cartao">
          <i class="far fa-address-card"></i>
        </div>
        <span class="atalho-card__titulo">Novo Cartão</span>
        <span class="atalho-card__subtitulo">Cadastrar cliente</span>
      </button>

      <!-- 4. Lançar Pontos -->
      <button type="button" class="atalho-card" *ngIf="temModuloFidelidade && temPermissaoAdicionarPontos" (click)="abraAdicionarPontos()">
        <div class="atalho-card__icone atalho-card__icone--pontos">
          <i class="fas fa-percentage"></i>
        </div>
        <span class="atalho-card__titulo">Lançar Pontos</span>
        <span class="atalho-card__subtitulo">Pontuar compras</span>
      </button>

      <!-- 5. Trocar Pontos -->
      <button type="button" class="atalho-card" *ngIf="temModuloFidelidade && temPermissaoResgatarBrindes" (click)="abraTrocarPontos()">
        <div class="atalho-card__icone atalho-card__icone--trocar">
          <i class="fas fa-gift"></i>
        </div>
        <span class="atalho-card__titulo">Trocar Pontos</span>
        <span class="atalho-card__subtitulo">Resgatar prêmios</span>
      </button>

      <!-- 6. Mensagens -->
      <button type="button" class="atalho-card" *ngIf="temModuloPedidos" (click)="abraAcompanharMensagens()">
        <div class="atalho-card__icone atalho-card__icone--mensagens">
          <i class="far fa-comment-dots"></i>
        </div>
        <span class="atalho-card__titulo">Mensagens</span>
        <span class="atalho-card__subtitulo">Disparos & Avisos</span>
      </button>
    </div>
  </section>

  </ng-template>

  <ng-template #tplPedidos>
  <!-- Últimos pedidos + Operação -->
  <div class="painel-duplo painel-duplo--operacao" *ngIf="temModuloPedidos">
    <!-- Coluna 2: Últimos Pedidos -->
    <div class="painel-card painel-card--pedidos" [class.painel-card--largo]="!exibirOperacao">
      <div class="painel-card__header">
        <div class="painel-card__header-info">
          <div class="painel-card__icone painel-card__icone--relogio">
            <i class="far fa-clock"></i>
          </div>
          <div>
            <h4 class="painel-card__titulo">Últimos Pedidos</h4>
            <p class="painel-card__subtitulo">Monitor de entrada em tempo real</p>
          </div>
        </div>
        <button type="button" class="btn-simular-pedido" (click)="simularPedido()">
          <i class="fas fa-plus"></i> Fazer Pedido na Loja
        </button>
      </div>

      <div class="pedidos-corpo">
        <!-- Vazio (quando não há pedidos) -->
        <div class="pedidos-vazio" *ngIf="!ultimosPedidos || ultimosPedidos.length === 0">
          <div class="pedidos-vazio__icone">
            <i class="fas fa-inbox"></i>
          </div>
          <h5 class="pedidos-vazio__titulo">Nenhum pedido registrado hoje ainda</h5>
          <p class="pedidos-vazio__texto">
            Assim que seus clientes fizerem o pedido no balcão ou delivery, ele aparecerá aqui com aviso sonoro.
          </p>
        </div>

        <!-- Lista de pedidos (quando há pedidos) -->
        <div class="pedidos-lista" *ngIf="ultimosPedidos && ultimosPedidos.length > 0">
          <button type="button" class="pedido-item" (click)="abraPedido(pedido)"
                  *ngFor="let pedido of ultimosPedidos.slice(0, 5); trackBy: identifiquePedido"
                  [class.pedido-item--novo]="ehPedidoNaoLido(pedido)">
            <span class="pedido-item__hora">{{horaDoPedido(pedido)}}</span>
            <div class="pedido-item__info">
              <span class="pedido-item__cliente">{{clienteDoPedido(pedido)}}</span>
              <span class="pedido-item__codigo">
                <span class="pedido-item__forma" *ngIf="formaDeEntregaDoPedido(pedido)">{{formaDeEntregaDoPedido(pedido)}}</span>
                #{{pedido.codigo}}
              </span>
            </div>
            <span class="pedido-item__status">{{statusDoPedido(pedido)}}</span>
            <span class="pedido-item__valor" *ngIf="exibirFinanceiro"><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: pedido.total}"></ng-container></span>
          </button>
        </div>
      </div>

      <div class="pedidos-footer">
        <span class="som-status">
          <span class="som-status__ponto"></span>
          Som de notificação ativado
        </span>
        <button type="button" class="btn-configurar-som" (click)="abrirConfiguracaoSom()">
          Configurar
        </button>
      </div>
    </div>

    <!-- Coluna 3: Operação (caixa e mesas), só com módulo e permissão -->
    <div class="painel-card painel-card--operacao" *ngIf="exibirOperacao">
      <div class="painel-card__header">
        <div class="painel-card__header-info">
          <div class="painel-card__icone painel-card__icone--operacao">
            <i class="fas fa-store"></i>
          </div>
          <div>
            <h4 class="painel-card__titulo">Operação</h4>
            <p class="painel-card__subtitulo">Caixa e salão agora</p>
          </div>
        </div>
      </div>

      <div class="operacao-lista">
        <button type="button" class="operacao-item" *ngIf="exibirCaixaNaOperacao" (click)="abraCaixa()">
          <span class="operacao-item__rotulo">Caixa</span>
          <span class="operacao-item__valor" *ngIf="operacao.caixa?.aberto">
            <span class="operacao-item__ponto operacao-item__ponto--ok"></span>
            aberto {{operacao.caixa.desde ? 'desde ' + operacao.caixa.desde : ''}}
          </span>
          <span class="operacao-item__valor operacao-item__valor--atencao" *ngIf="!operacao.caixa?.aberto">
            <span class="operacao-item__ponto"></span>
            fechado
          </span>
          <span class="operacao-item__detalhe" *ngIf="operacao.caixa?.aberto">{{operacao.caixa.operador ? 'por ' + operacao.caixa.operador : 'em operação'}}</span>
          <span class="operacao-item__link">{{operacao.caixa?.aberto ? 'ver caixa' : 'abrir caixa'}} ›</span>
        </button>

        <button type="button" class="operacao-item operacao-item--mesas" *ngIf="exibirMesasNaOperacao" (click)="abraMesas()">
          <span class="operacao-item__rotulo">Mesas</span>
          <span class="operacao-item__valor">{{operacao.mesas.ocupadas}} de {{operacao.mesas.total}} ocupadas</span>
          <span class="operacao-item__barra"><span [style.width.%]="ocupacaoMesas"></span></span>
          <span class="operacao-item__detalhe">{{operacao.mesas.comandas}} {{operacao.mesas.comandas === 1 ? 'comanda aberta' : 'comandas abertas'}}</span>
          <span class="operacao-item__link">ver comandas ›</span>
        </button>
      </div>

      <button type="button" class="btn-mapa-salao" *ngIf="exibirMesasNaOperacao" (click)="abraMesas()">
        <i class="fas fa-th-large"></i> Mapa completo do salão
      </button>
    </div>
  </div>

  </ng-template>

  <ng-template #tplCardapio>
  <!-- Cardápio digital em faixa: o operador quase não usa, fica baixo e largo -->
  <div class="painel-duplo painel-duplo--faixa" *ngIf="temModuloPedidos">
    <div class="painel-card painel-card--cardapio painel-card--faixa">
      <div class="painel-card__header">
        <div class="painel-card__header-info">
          <div class="painel-card__icone painel-card__icone--qrcode">
            <i class="fas fa-qrcode"></i>
          </div>
          <div>
            <h4 class="painel-card__titulo">Cardápio Digital & QR Code</h4>
            <p class="painel-card__subtitulo" *ngIf="!contaNova">Pronto para imprimir, colar nas mesas ou enviar no WhatsApp</p>
            <p class="painel-card__subtitulo" *ngIf="contaNova">Seu primeiro passo: mande o link no WhatsApp ou imprima o QR e receba o primeiro pedido</p>
          </div>
        </div>
        <span class="badge-pill" *ngIf="!contaNova">Mesa & Balcão</span>
        <span class="badge-pill badge-pill--comece" *ngIf="contaNova">Comece por aqui</span>
      </div>

      <div class="cardapio-corpo">
        <div class="qrcode-caixa">
          <img class="qrcode-imagem" [src]="'/qrcode/qrcodeloja'" alt="QR Code da loja"
               (error)="qrcodeErro = true" *ngIf="!qrcodeErro" />
          <div class="qrcode-placeholder" *ngIf="qrcodeErro">
            <i class="fas fa-qrcode"></i>
          </div>
          <button type="button" class="btn-escanear" (click)="abrirQrCodePreview()">
            <i class="fas fa-expand"></i> Ampliar
          </button>
        </div>

        <div class="cardapio-detalhes">
          <label class="cardapio-label">LINK PÚBLICO DO CARDÁPIO</label>
          <div class="cardapio-link-box">
            {{linkCardapio}}
          </div>
          <p class="cardapio-descricao">
            Ao acessar este link, seus clientes veem fotos em alta definição, fazem pedidos sem filas e acumulam pontos automaticamente.
          </p>
        </div>
      </div>

      <div class="cardapio-acoes">
        <button type="button" class="btn-cardapio btn-cardapio--copiar" [class.copiado]="linkCopiado" (click)="copieLinkDaLoja()">
          <i class="far" [ngClass]="linkCopiado ? 'fa-check-circle' : 'fa-copy'"></i>
          {{linkCopiado ? 'Link copiado!' : 'Copiar link'}}
        </button>

        <a class="btn-cardapio btn-cardapio--outline" [href]="linkCardapio" target="_blank" rel="noopener">
          <i class="fas fa-external-link-alt"></i>
          Abrir loja
        </a>

        <a class="btn-cardapio btn-cardapio--outline" href="/qrcode/qrcodeloja" download="qrcode-cardapio.png">
          <i class="fas fa-download"></i>
          Baixar QR Code
        </a>
      </div>
    </div>
  </div>

  </ng-template>

  <ng-template #tplFidelidade>
  <!-- SEÇÃO 4: Desempenho do Programa de Fidelidade -->
  <section class="secao-fidelidade" *ngIf="temModuloFidelidade">
    <!-- Onboarding para quem ainda não tem clientes -->
    <div class="row mt-3" *ngIf="resumo && resumo.total == 0">
      <div class="col-12 col-lg-6 mb-3">
        <div class="card card-onboarding">
          <div class="card-body" style="max-height: 450px;">
            <div class="row align-items-center justify-content-center">
              <div class="col-12 col-lg-6">
                <div class="row align-items-center">
                  <div class="col" style="flex: 0 0 50px;">
                    <img src="/assets/fidelidade/icones/icon-user-plus.svg" alt="Não perca clientes"/>
                  </div>
                  <div class="col pl-0 mt-3 pr-0">
                    <h2 style="color: #6EB923" class="mb-0">Não perca clientes</h2>
                    <p class="text-muted" style="font-size: 15px">Fidelize seu cliente através de apenas 1 número de WhatsApp.</p>
                  </div>
                </div>
              </div>
              <div class="col-6 mr-0 pl-0">
                <img src="/assets/fidelidade/icones/ilustration-whatsapp.png" class="img-fluid" style="max-height: 257px;" alt="WhatsApp Fidelidade"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-3">
        <div class="card card-onboarding">
          <div class="card-body" style="max-height: 450px;">
            <div class="row align-items-center justify-content-center">
              <div class="col-12 col-lg-6">
                <div class="row align-items-center">
                  <div class="col" style="flex: 0 0 50px;">
                    <img src="/assets/fidelidade/icones/icon-fidelidade-pink.svg" alt="Fidelização"/>
                  </div>
                  <div class="col pl-0 mt-3 pr-0">
                    <h1 style="color: #EE4E61" class="mb-0">Fidelização</h1>
                    <p class="text-muted" style="font-size: 15px">Crie cartões de fidelidade para seus clientes e aumente em até 30% sua receita.</p>
                  </div>
                </div>
              </div>
              <div class="col-6 mr-0 pl-0">
                <img src="/assets/fidelidade/icones/ilustration-selo.png" class="img-fluid" style="margin-left: 10px; max-height: 450px;" alt="Selo Fidelidade"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Resumo do programa: cartões, pontos e receita do período -->
    <div class="fidelidade-resumo-card mb-4" *ngIf="resumo && resumo.total > 0">
      <div class="fidelidade-resumo-card__topo">
        <h4 class="vendas-card__titulo">Fidelidade</h4>
        <span class="pill-novos-mes" *ngIf="novosCartoesMes > 0">+{{novosCartoesMes}} este mês</span>
      </div>
      <div class="fidelidade-resumo fidelidade-resumo--linha">
        <div class="fidelidade-resumo__item">
          <span class="fidelidade-resumo__valor">{{(resumo?.total || 0) | number}}</span>
          <span class="fidelidade-resumo__rotulo">cartões</span>
        </div>
        <div class="fidelidade-resumo__item">
          <span class="fidelidade-resumo__valor">{{(resumoVenda.pontos || 0) | number: '1.0-2'}}</span>
          <span class="fidelidade-resumo__rotulo">pontos no período</span>
        </div>
        <div class="fidelidade-resumo__item" *ngIf="exibirFinanceiro && resumoVenda.total">
          <span class="fidelidade-resumo__valor"><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: resumoVenda.total}"></ng-container></span>
          <span class="fidelidade-resumo__rotulo">em compras de clientes do programa <ng-container *ngTemplateOutlet="seloGestorTpl"></ng-container><ng-container *ngTemplateOutlet="olhoTpl"></ng-container></span>
        </div>
      </div>
    </div>

    <!-- Gráfico de Receita de Fidelidade (quando tem clientes e permissão financeira) -->
    <div class="fidelidade-grafico-card mb-4" *ngIf="resumo && resumo.total > 0 && exibirFinanceiro">
      <div class="fidelidade-grafico-header">
        <div class="fidelidade-grafico-header__info">
          <div class="fidelidade-grafico-icone">
            <i class="fas fa-chart-area"></i>
          </div>
          <div>
            <h4 class="fidelidade-grafico-titulo">Receita de Fidelidade</h4>
            <p class="fidelidade-grafico-subtitulo">
              Compras geradas por clientes participantes do programa
              <span class="badge-fidelidade-receita ml-2" *ngIf="resumoVenda.total">
                Total no período: <strong><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: resumoVenda.total}"></ng-container></strong>
              </span>
            </p>
          </div>
        </div>

        <div class="periodo-filtros">
          <button type="button" class="periodo-btn" [class.ativo]="tipoGrafico === 'dia'" (click)="exibaGraficoDia()">Dia</button>
          <button type="button" class="periodo-btn" [class.ativo]="tipoGrafico === 'mes'" (click)="exibaGraficoMes()">Mês</button>
          <button type="button" class="periodo-btn" [class.ativo]="tipoGrafico === 'ano'" (click)="exibaGraficoAno()">Ano</button>
        </div>
      </div>

      <div class="pt-1 pb-1">
        <kendo-chart [categoryAxis]="{ categories: seriesLabels }" [transitions]="false">
          <kendo-chart-category-axis>
            <kendo-chart-category-axis-item [categories]="seriesLabels" [majorGridLines]="{ visible: false }" [line]="{ color: '#e2e8f0' }">
              <kendo-chart-category-axis-item-labels [rotation]="90" [font]="fonteGrafico" [color]="corRotuloGrafico">
              </kendo-chart-category-axis-item-labels>
            </kendo-chart-category-axis-item>
          </kendo-chart-category-axis>

          <kendo-chart-value-axis>
            <kendo-chart-value-axis-item [min]="0" [majorGridLines]="{ color: '#eef2f7' }" [line]="{ visible: false }">
              <kendo-chart-value-axis-item-labels format="c0" [visible]="!valoresOcultos" [font]="fonteGrafico" [color]="corRotuloGrafico">
              </kendo-chart-value-axis-item-labels>
            </kendo-chart-value-axis-item>
          </kendo-chart-value-axis>

          <kendo-chart-legend [visible]="false"></kendo-chart-legend>
          <kendo-chart-area [margin]="10" background="transparent"></kendo-chart-area>
          <kendo-chart-tooltip [padding]="8" [background]="'#ffffff'" [color]="'#0f172a'" [border]="{ color: '#e2e8f0', width: 1 }"></kendo-chart-tooltip>
          <kendo-chart-series>
            <kendo-chart-series-item [data]="series | async" [type]="'area'" color="#4f46e5"
                                     [opacity]="0.12" [line]="{ width: 0 }" [markers]="{ visible: false }"
                                     [tooltip]="{ visible: false }">
            </kendo-chart-series-item>

            <kendo-chart-series-item [data]="series | async" [type]="'line'" color="#4f46e5" [width]="2"
                                     [markers]="{ visible: true, size: 6, background: '#ffffff', border: { color: '#4f46e5', width: 2 } }">
              <kendo-chart-series-item-tooltip>
                <ng-template let-value="value" let-category="category">
                  <div class="grafico-tooltip" style="color: #0f172a;">
                    <div class="grafico-tooltip__dia">{{category}}</div>
                    <div class="grafico-tooltip__linha"><span class="grafico-tooltip__ponto"></span><strong><ng-container *ngTemplateOutlet="moedaTpl; context: {$implicit: value}"></ng-container></strong></div>
                  </div>
                </ng-template>
              </kendo-chart-series-item-tooltip>
            </kendo-chart-series-item>
          </kendo-chart-series>
        </kendo-chart>
      </div>
    </div>

    <!-- Feed / Tabela de Últimas Ações do Fidelidade -->
    <div class="fidelidade-acoes-card mb-4" *ngIf="ultimasAcoes && ultimasAcoes.length > 0">
      <div class="fidelidade-acoes-header">
        <div class="fidelidade-acoes-header__info">
          <div class="fidelidade-acoes-icone">
            <i class="fas fa-history"></i>
          </div>
          <div>
            <h4 class="fidelidade-acoes-titulo">Últimas ações do Fidelidade</h4>
            <p class="fidelidade-acoes-subtitulo">Movimentações de selos, pontos e resgates de clientes</p>
          </div>
        </div>
        <button type="button" class="btn-ver-todas" *ngIf="ultimasAcoes.length > limiteAcoes" (click)="exibirTodasAcoes = !exibirTodasAcoes">
          {{exibirTodasAcoes ? 'Ver menos' : 'Ver todas (' + ultimasAcoes.length + ')'}}
        </button>
      </div>

      <div class="table-responsive">
        <table class="table table-centered table-hover mb-0 fidelidade-tabela">
          <thead>
            <tr>
              <th style="width: 40px; min-width: 40px;"></th>
              <th>Contato</th>
              <th>Ação</th>
              <th style="width: 160px;">Horário</th>
              <th style="width: 70px; text-align: right;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let acao of (exibirTodasAcoes ? ultimasAcoes : (ultimasAcoes | slice:0:limiteAcoes))">
              <td style="width: 40px; min-width: 40px; text-align: center;">
                <span class="fidelidade-icone-bolha">
                  <app-icone-acao [acao]="acao" [exibirDescricao]="false"></app-icone-acao>
                </span>
              </td>
              <td>
                <div class="d-flex align-items-center">
                  <div *ngIf="acao.tipo == tipoDeAcaoEnum.NOVO_CONTATO" class="icone_svg mr-2"
                       [inlineSVG]="'/assets/fidelidade/icones/novoscartoes-dashboard.svg'"
                       [removeSVGAttributes]="['fill', 'width', 'height']"></div>
                  <div *ngIf="acao.tipo == tipoDeAcaoEnum.GANHOU_PONTOS" class="icone_svg mr-2"
                       [inlineSVG]="'/assets/fidelidade/icones/novoselo.svg'"
                       [removeSVGAttributes]="['fill', 'width', 'height']"></div>
                  <div class="icone_svg icone_svg--trocar mr-2" *ngIf="acao.tipo == tipoDeAcaoEnum.TROCOU_PONTOS">
                    <div class="icone_trocar_pontos" [inlineSVG]="'/assets/fidelidade/icones/trocar-selo.svg'"
                         [removeSVGAttributes]="['fill', 'width', 'height']"></div>
                  </div>
                  <a routerLink="/admin/contatos/{{acao.contato?.codigoPais}}{{acao.contato?.telefone}}" class="fidelidade-contato-link">
                    {{acao.contato?.nome || 'Cliente'}}
                  </a>
                </div>
              </td>
              <td>
                <span class="fidelidade-acao-desc">{{acao.descricao}}</span>
              </td>
              <td>
                <span class="fidelidade-acao-hora">{{acao.horario}}</span>
              </td>
              <td class="text-right">
                <a href="/imprimir/troca/{{acao.brinde.codigo}}" target="_blank" *ngIf="acao.brinde"
                   class="btn-acao-imprimir" title="Imprimir comprovante de troca">
                  <i class="fa fa-print"></i>
                </a>
                <a href="/imprimir/pontuacao/{{acao.pontuacao.codigo}}" target="_blank" *ngIf="acao.pontuacao && acao.tipo == 2"
                   class="btn-acao-imprimir" title="Imprimir comprovante de pontuação">
                  <i class="fa fa-print"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

  </ng-template>

  <!-- Componentes em segundo plano -->
  <botoes-home #botoesHome [empresa]="empresa" [tela]="this" style="display: none;"></botoes-home>
  <ng-container *ngIf="iframe">
    <app-notificacoes-promokit></app-notificacoes-promokit>
  </ng-container>
  <app-gerenciador-envio-campanha></app-gerenciador-envio-campanha>

  <kendo-dialog *ngIf="fatura && fatura.vencida && !exibirModal" (close)="fecheModal()"
                 class="modal-cobranca modal-cobranca--atraso">
    <kendo-dialog-titlebar>
      <div class="fatura-dialog__titulo">
        <span class="fatura-dialog__titulo-icone fatura-dialog__titulo-icone--atraso">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        <div>
          <strong>Fatura em atraso</strong>
          <small>Evite o bloqueio do sistema efetuando o pagamento.</small>
        </div>
      </div>
    </kendo-dialog-titlebar>

    <div class="fatura-dialog">
      <div class="fatura-dialog__mensagem fatura-dialog__mensagem--atraso">
        <i class="fas fa-exclamation-circle"></i>
        <p>
          <strong>Atenção!</strong> A fatura com vencimento em <b>{{fatura.dataVencimentoFormatada || fatura.dataVencimento}}</b> venceu e o pagamento
          não foi identificado no sistema.<br>
          Caso já tenha realizado o pagamento, envie o comprovante no <b>grupo de atendimento do WhatsApp</b>
          ou entre em contato com o seu consultor.
        </p>
      </div>

      <app-fatura-aberta-pagar [fatura]="fatura" [emModal]="true"></app-fatura-aberta-pagar>
    </div>

    <kendo-dialog-actions layout="end">
      <button type="button" class="btn fatura-dialog__fechar fatura-dialog__fechar--principal"
              (click)="fecheModal()">Entendi, fechar</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <kendo-dialog class="modal-cobranca" *ngIf="fatura && fatura.venceHoje && !exibirModal" (close)="fecheModal()">
    <kendo-dialog-titlebar>
      <div class="fatura-dialog__titulo">
        <span class="fatura-dialog__titulo-icone">
          <i class="fas fa-check"></i>
        </span>
        <div>
          <strong>Fatura disponível para pagamento</strong>
          <small>Realize o pagamento até o vencimento para evitar juros e bloqueios.</small>
        </div>
      </div>
    </kendo-dialog-titlebar>

    <div class="fatura-dialog">
      <div class="fatura-dialog__mensagem">
        <i class="fas fa-info-circle"></i>
        <p>
          <strong>Sua fatura já está disponível.</strong>
          O vencimento é hoje, <b>{{fatura.dataVencimentoFormatada || fatura.dataVencimento}}</b>. Confira abaixo as formas de pagamento disponíveis.
          Após a identificação do pagamento, a baixa ocorrerá automaticamente no sistema.
        </p>
      </div>

      <app-fatura-aberta-pagar [fatura]="fatura" [emModal]="true"></app-fatura-aberta-pagar>
    </div>

    <kendo-dialog-actions layout="end">
      <button type="button" class="btn fatura-dialog__fechar" (click)="fecheModal()">Fechar</button>
    </kendo-dialog-actions>
  </kendo-dialog>

  <kendo-dialog
    title="Avisos da Plataforma"
    class="modal-avisos-plataforma"
    *ngIf="exibirModalAvisosAtualizacao && avisoAtualizacaoAtual"
    (close)="fecheModalAvisosAtualizacao()"
    [width]="dialogWidth">

    <div class="aviso-atualizacao-dialog">
      <div class="aviso-atualizacao-dialog__hero">
        <div class="aviso-atualizacao-dialog__icone" [ngClass]="obtenhaClasseTipoAvisoPlataforma(avisoAtualizacaoAtual.tipo)">
          <i class="fas" [ngClass]="obtenhaIconeTipoAvisoPlataforma(avisoAtualizacaoAtual.tipo)"></i>
        </div>

        <div class="aviso-atualizacao-dialog__hero-conteudo">
          <div class="aviso-atualizacao-dialog__meta">
            <div class="d-flex align-items-center flex-wrap" style="gap: 6px;">
              <span class="aviso-pill" [ngClass]="obtenhaClasseTipoAvisoPlataforma(avisoAtualizacaoAtual.tipo)">
                {{ obtenhaRotuloTipoAvisoPlataforma(avisoAtualizacaoAtual.tipo) }}
              </span>
              <span class="aviso-pill" [ngClass]="obtenhaClassePrioridadeAvisoAtualizacao(avisoAtualizacaoAtual.prioridade)">
                {{ obtenhaTextoPrioridadeAvisoAtualizacao(avisoAtualizacaoAtual.prioridade) }}
              </span>
            </div>

            <span class="aviso-atualizacao-dialog__contador" *ngIf="totalAvisosAtualizacao > 1">
              {{ indiceAvisoAtualizacao + 1 }} de {{ totalAvisosAtualizacao }}
            </span>
          </div>

          <h4 class="aviso-atualizacao-dialog__titulo">{{ avisoAtualizacaoAtual.titulo }}</h4>
          <p class="aviso-atualizacao-dialog__resumo" *ngIf="avisoAtualizacaoAtual.resumo">{{ avisoAtualizacaoAtual.resumo }}</p>
        </div>
      </div>

      <div class="aviso-atualizacao-dialog__bloco">
        <div class="aviso-atualizacao-dialog__bloco-titulo">Detalhes do aviso</div>

        <div class="aviso-atualizacao-dialog__conteudo">
          <ng-container *ngFor="let bloco of obtenhaBlocosConteudoAvisoAtualizacao(avisoAtualizacaoAtual.conteudo)">
            <p class="aviso-atualizacao-dialog__paragrafo" *ngIf="bloco.tipo === 'paragrafo'">
              {{ bloco.itens[0] }}
            </p>

            <ul class="aviso-atualizacao-dialog__lista" *ngIf="bloco.tipo === 'lista'">
              <li *ngFor="let item of bloco.itens">
                <span class="aviso-atualizacao-dialog__lista-check">
                  <i class="fas fa-check"></i>
                </span>
                <span>{{ item }}</span>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>

      <div class="aviso-atualizacao-dialog__cta" *ngIf="avisoAtualizacaoAtual.linkAcao || avisoAtualizacaoAtual.textoAcao">
        <span class="aviso-atualizacao-dialog__cta-dica" *ngIf="avisoAtualizacaoAtual.linkAcao">
          Saiba mais sobre este aviso:
        </span>

        <a
          class="aviso-atualizacao-dialog__cta-botao"
          *ngIf="avisoAtualizacaoAtual.linkAcao; else botaoAcaoInternaAviso"
          target="_blank"
          rel="noopener noreferrer"
          href="{{avisoAtualizacaoAtual.linkAcao}}">
          <i class="fas fa-external-link-alt aviso-atualizacao-dialog__cta-icone"></i>
          {{ avisoAtualizacaoAtual.textoAcao || 'Abrir link relacionado' }}
        </a>

        <ng-template #botaoAcaoInternaAviso>
          <button
            type="button"
            class="aviso-atualizacao-dialog__cta-botao"
            (click)="proximoAvisoAtualizacao()">
            {{ avisoAtualizacaoAtual.textoAcao || 'Continuar' }}
            <i class="fas fa-arrow-right aviso-atualizacao-dialog__cta-icone"></i>
          </button>
        </ng-template>
      </div>
    </div>

    <kendo-dialog-actions>
      <div class="aviso-atualizacao-dialog__footer">
        <div class="aviso-atualizacao-dialog__progresso" *ngIf="totalAvisosAtualizacao > 1">
          <span
            *ngFor="let dot of [].constructor(totalAvisosAtualizacao); let i = index"
            class="aviso-atualizacao-dialog__progresso-dot"
            [class.aviso-atualizacao-dialog__progresso-dot--ativo]="i === indiceAvisoAtualizacao">
          </span>
        </div>

        <div class="aviso-atualizacao-dialog__footer-acoes">
          <button
            type="button"
            class="btn aviso-atualizacao-dialog__acao aviso-atualizacao-dialog__acao--voltar"
            *ngIf="temAvisoAtualizacaoAnterior"
            (click)="avisoAtualizacaoAnterior()">
            <i class="fas fa-chevron-left mr-1"></i>
            Voltar
          </button>

          <button
            type="button"
            class="btn aviso-atualizacao-dialog__acao aviso-atualizacao-dialog__acao--secundaria"
            (click)="verDepoisAvisoAtualizacao()">
            Lembrar depois
          </button>

          <button
            type="button"
            class="btn aviso-atualizacao-dialog__acao aviso-atualizacao-dialog__acao--principal"
            (click)="proximoAvisoAtualizacao()">
            {{ temProximoAvisoAtualizacao ? 'Entendi, continuar' : 'Concluir' }}
            <i class="fas fa-chevron-right ml-1" *ngIf="temProximoAvisoAtualizacao"></i>
            <i class="fas fa-check ml-1" *ngIf="!temProximoAvisoAtualizacao"></i>
          </button>
        </div>
      </div>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>

<!-- Chip de variação, sem frase: a referência completa vai no title -->
<ng-template #chipTpl let-comparativo>
  <span class="pill-comparativo" [ngClass]="'pill-comparativo--' + (comparativo.tom || 'igual')" *ngIf="comparativo.chip" [title]="comparativo.texto">
    <i class="fas" [ngClass]="comparativo.tom === 'alta' ? 'fa-arrow-up' : (comparativo.tom === 'baixa' ? 'fa-arrow-down' : 'fa-equals')"></i>
    {{comparativo.chip === 'igual' ? 'igual' : comparativo.chip}}
  </span>
</ng-template>

<!-- Olho dos valores: repetido em cada cartão que mostra dinheiro, ao lado do
     selo Gestor, para quem chega no meio da página saber por que vê "•••••"
     e como revelar. Um único estado para a home inteira. -->
<ng-template #olhoTpl>
  <button type="button" class="olho-valores" (click)="alterneValores()" [attr.aria-pressed]="!valoresOcultos"
          [attr.data-tooltip]="valoresOcultos
            ? 'Os valores em dinheiro da home estão ocultos. Clique para mostrar. Só as variações em % continuam visíveis.'
            : 'Esconde valores e quantidades da home, útil com a tela à vista de outras pessoas. Ao recarregar a página, volta a esconder.'">
    <i class="fas" [ngClass]="valoresOcultos ? 'fa-eye' : 'fa-eye-slash'" aria-hidden="true"></i>
    <span>{{valoresOcultos ? 'Mostrar valores' : 'Ocultar valores'}}</span>
  </button>
</ng-template>

<!-- Valor em dinheiro: quando oculto, o próprio "R$ •••••" é o controle, com
     tooltip e clique para revelar, para quem topa com ele no meio da página.
     Quem está dentro de um botão (fila de pedidos) não dispara o botão. -->
<ng-template #moedaTpl let-valor>
  <ng-container *ngIf="!valoresOcultos">{{moeda(valor)}}</ng-container>
  <span class="valor-mascarado" *ngIf="valoresOcultos" role="button" tabindex="0"
        data-tooltip="Oculto · clique para ver"
        (click)="alterneValores($event)" (keydown.enter)="alterneValores($event)">R$ <span class="valor-mascarado__pontos">•••••</span><i class="fas fa-eye" aria-hidden="true"></i></span>
</ng-template>
<ng-template #qtdeTpl let-valor>
  <ng-container *ngIf="!valoresOcultos">{{valor}}</ng-container>
  <span class="valor-mascarado" *ngIf="valoresOcultos" role="button" tabindex="0"
        data-tooltip="Oculto · clique para ver"
        (click)="alterneValores($event)" (keydown.enter)="alterneValores($event)"><span class="valor-mascarado__pontos">•••</span><i class="fas fa-eye" aria-hidden="true"></i></span>
</ng-template>
<ng-template #numeroTpl let-valor>
  <ng-container *ngIf="!valoresOcultos">{{numero(valor)}}</ng-container>
  <span class="valor-mascarado" *ngIf="valoresOcultos" role="button" tabindex="0"
        data-tooltip="Oculto · clique para ver"
        (click)="alterneValores($event)" (keydown.enter)="alterneValores($event)"><span class="valor-mascarado__pontos">•••••</span><i class="fas fa-eye" aria-hidden="true"></i></span>
</ng-template>

<!-- Selo de permissão: o que está neste card só quem tem "Visualizar vendas" enxerga -->
<ng-template #seloGestorTpl>
  <span class="selo-gestor" tabindex="0" role="note"
        data-tooltip="Funcionários sem a permissão “Visualizar vendas” não veem este bloco. Dono e gestores veem normalmente.">
    <i class="fas fa-lock"></i> Gestor
  </span>
</ng-template>
